import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SnackbarService } from '@services/snackbar/snackbar.service';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { PipeImportService } from '@services/pipe-imports/pipe-import.service';
import { Models } from '@ibexfusion/models';
import { PipeImportModuleModels } from './pipe-import-modules';
import { HttpClient } from '@angular/common/http';

import * as _ from 'lodash';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OrganisationSelectionComponent } from '../../../components/popUpSelects/organisation-selection/organisation-selection.component';
import { OrganisationService } from '@services/organisations/organisation.service';
import { EnvironmentService } from '@services/environment/environment.service';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
    selector: 'app-pipe-import-edit',
    templateUrl: './pipe-import-edit.component.html',
    styleUrls: ['./pipe-import-edit.component.scss'],
    providers: [PipeImportService, OrganisationService],
    standalone: false
})
export class PipeImportEditComponent implements OnInit {

  isLoading = false;

  pipeImportId: string;

  title = 'Create new Pipe Importer';

  pipeImport: Models.PipeImport;

  create = false;

  organisation: Models.Organisation = null;

  uploadedFileUrl: string;
  uploadedFile: any;

  testResult: any = null;
  testResultIsObject = false;
  showAsString = false;

  public pageActions: PageAction[];
  public fabButtons;
  public options: any = { mode: 'view', expandAll: false };

  constructor(
    private activatedRoute: ActivatedRoute, private pipeImportService: PipeImportService, private organisationService: OrganisationService, private http: HttpClient,
    private snackbar: SnackbarService, private router: Router, private dialog: MatDialog, private dialogService: DialogService, private environmentService: EnvironmentService
  ) {
    const fabButtons = [];
    for (const key in PipeImportModuleModels) {
      if (PipeImportModuleModels[key]) {
        const buttons = [];
        for (const moduleKey in PipeImportModuleModels[key]) {
          if (moduleKey && PipeImportModuleModels[key].hasOwnProperty(moduleKey)) {
            buttons.push({ title: moduleKey })
          }
        }
        fabButtons.push({ title: key, buttons: buttons });
      }

    }
    this.fabButtons = fabButtons;
  }

  ngOnInit() {
    this.createPageActions();
    if (this.activatedRoute.snapshot.params['id']) {
      this.pipeImportId = this.activatedRoute.snapshot.params['id'];
      this.pipeImportService.get(this.pipeImportId).then(result => {
        this.pipeImport = result;
        if (this.pipeImport.OwnerOrganisationID) {
          this.organisationService.get(this.pipeImport.OwnerOrganisationID).then(organisation => {
            this.organisation = organisation;
          })
        }
        if (this.pipeImport.modules) {
          for (let i = 0; i < this.pipeImport.modules.length; i++) {
            const dataModel = Models.ModelFactory.createModelInstanceByName(PipeImportModuleModels[this.pipeImport.modules[i].group][this.pipeImport.modules[i].module]);
            dataModel.populateFromJSON(this.pipeImport.modules[i].data);
            const module = new Models.PipeModule();
            module.populateFromJSON({ group: this.pipeImport.modules[i].group, module: this.pipeImport.modules[i].module });
            module.data = dataModel;
            this.pipeImport.modules[i] = module;
          }
        }
        this.title = this.pipeImport.title;
        this.isLoading = false;
      });
    } else {
      this.create = true;
      this.pipeImport = <Models.PipeImport>Models.ModelFactory.createModelInstanceByName('PipeImport');
      this.isLoading = false;
    }
  }

  onModuleSelected(event: any) {
    const dataModel = Models.ModelFactory.createModelInstanceByName(PipeImportModuleModels[event.group][event.module]);
    const module = new Models.PipeModule();
    module.populateFromJSON({ group: event.group, module: event.module });
    module.data = dataModel;
    if (!this.pipeImport.modules) {
      this.pipeImport.modules = [];
    }
    this.pipeImport.modules.push(module);
  }

  onTest(index: number, event: any) {
    event.stopPropagation();
    let postData = _.clone(this.pipeImport);
    if (index >= 0) {
      postData.modules = this.pipeImport.modules.slice(0, index + 1);
    }
    if (postData.modules[0].group === 'Request' && postData.modules[0].module === 'Upload' && !!this.uploadedFile) {
      postData.modules[0] = <any>{ group: 'Request', module: 'Get', data: { url: this.uploadedFileUrl } };
    }
    if (this.pipeImportId) {
      postData = JSON.parse(JSON.stringify(postData).replace(/pipeImportId/, this.pipeImportId));
    }
    return this.http.post(this.environmentService.getPipeBackendUrl() + 'complex/', postData).toPromise().then(result => {
      this.testResult = result;
      this.testResultIsObject = _.isObject(result);
    }).catch(err => {
      console.error(err);
    });
  }

  onRemove(index: number) {
    const module = this.pipeImport.modules[index];
    this.dialogService.confirm('Remove Module ' + module.group + ' - ' + module.module + ' from Pipe-Importer ?')
      .then(res => {
        if (!res) {
          return;
        }
        this.pipeImport.modules.splice(index, 1);
      });
  }

  onMoveUp(index: number, event: any) {
    event.stopPropagation();
    this.moveItem(index, index - 1);
  }

  onMoveDown(index: number, event: any) {
    event.stopPropagation();
    this.moveItem(index, index + 1);
  }

  onSave() {
    return this.pipeImport.validate(true).then(result => {
      if (result.success) {
        if (this.pipeImportId) {
          if (this.pipeImport.modules[0].group === 'Request' && this.pipeImport.modules[0].module === 'Upload' && this.uploadedFile) {
            this.uploadedFile.pipeId = this.pipeImportId;
            this.http.post(this.environmentService.getPipeBackendUrl() + 'uploadSourceFile/', this.uploadedFile).subscribe(() => {
              this.pipeImportService.patch(this.pipeImportId, this.pipeImport).then(() => {
              });
            });
          } else {
            this.pipeImportService.patch(this.pipeImportId, this.pipeImport).then(() => {
            });
          }
        } else {
          if (this.pipeImport.modules[0].group === 'Request' && this.pipeImport.modules[0].module === 'Upload') {
            if (!this.uploadedFile) {
              this.dialogService.confirm('Please upload an initial file').then(res => {
              });
              return;
            } else {
              this.pipeImportService.create(this.pipeImport).then(newImport => {
                this.uploadedFile.pipeId = newImport._id;
                this.http.post(this.environmentService.getPipeBackendUrl() + 'uploadSourceFile/', this.uploadedFile).subscribe(() => {
                  this.router.navigate(['pipe-imports', newImport._id, 'edit']);
                });
              }).catch(err => {
                console.warn(err);
              });
            }
          } else {
            this.pipeImportService.create(this.pipeImport).then(newImport => {
              this.router.navigate(['pipe-imports', newImport._id, 'edit']);
            });
          }
        }
      } else {
        this.snackbar.open('Could not create the pipe importer, please fill in the form correctly');
      }
    });
  }

  assignOrganisation() {
    let dialogRef: MatDialogRef<OrganisationSelectionComponent>;

    dialogRef = this.dialog.open(OrganisationSelectionComponent, <any>{ width: '600px' });

    return dialogRef.afterClosed().toPromise().then(result => {
      if (result) {
        this.organisation = result;
        this.pipeImport.OwnerOrganisationID = <any>this.organisation.OrganisationID;
      }
    });
  }

  removeOrganisation() {
    this.pipeImport.OwnerOrganisationID = null;
    this.organisation = null;
  }

  fileGiven(event) {
    const src = event.target || event.srcElement;
    if (!src.files[0]) {
      return;
    }
    console.log('File size before upload: ', src.files[0].size);
    // todo check max upload filesize for movies;

    const reader = new FileReader();
    reader.addEventListener('load', () => {
      const asset = <any>{};
      if (typeof reader.result === 'string') {
        asset.data = reader.result;
      } else {
        asset.data = reader.result.toString();
      }
      asset.originalFileName = src.files[0].name;
      this.uploadedFile = asset;
      return this.http.post(this.environmentService.getPipeBackendUrl() + 'uploadSourceFile/', asset)
        .subscribe((result: { url: string, ETag: string }) => {
          this.uploadedFileUrl = result.url;
        });
    });
    reader.readAsDataURL(src.files[0]);
  }

  private moveItem(from, to) {
    const f = this.pipeImport.modules.splice(from, 1)[0];
    this.pipeImport.modules.splice(to, 0, f);
  }

  private createPageActions(): void {
    this.pageActions = [new PageAction({
      icon: 'save',
      title: 'Save',
      callback: () => {
        this.onSave();
      }
    })];
    if (this.activatedRoute.snapshot.params['id']) {
      this.pageActions.push(new PageAction({
        icon: 'rowing',
        title: 'Execute',
        callback: () => {
          this.pipeImportService.patch(this.pipeImportId, <any>{ forcedExecution: true });
        }
      }));
      this.pageActions.push(new PageAction({
        icon: 'receipt',
        title: 'Logs',
        callback: () => {
          this.router.navigate(['pipe-imports/', this.activatedRoute.snapshot.params['id'], 'logs']);
        }
      }));
    }
  }

  stringify(data) {
    try {
      return JSON.stringify(data);
    } catch (err) {
      return data;
    }
  }
}
